import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const clearBlogError = () => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.BLOG_HTTP_ERROR,
      payload: {
        clear: true
      }
    });
  };
};

export const addBlog = (title: string, content: string, cover_img: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.BLOG_HTTP_LOADING
    });

    request({ method: "post", pathname: "addBlog", data: { title, content, cover_img } })
      .then((response) => {
        dispatch({
          type: actions.BLOG_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.BLOG_HTTP_ERROR, error, dispatch);
      });
  };
};

export const updateBlog = (_id: string, title: string, content: string, cover_img: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.BLOG_HTTP_LOADING
    });

    request({ method: "post", pathname: "updateBlog", data: { _id, title, content, cover_img } })
      .then((response) => {
        dispatch({
          type: actions.BLOG_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.BLOG_HTTP_ERROR, error, dispatch);
      });
  };
};

export const deleteBlog = (_id: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.BLOG_HTTP_LOADING
    });

    request({ method: "post", pathname: "deleteBlog", data: { _id } })
      .then((response) => {
        dispatch({
          type: actions.BLOG_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.BLOG_HTTP_ERROR, error, dispatch);
      });
  };
};
